import { render, staticRenderFns } from "./UploadImgOne.vue?vue&type=template&id=0796fd34&scoped=true&"
import script from "./UploadImgOne.vue?vue&type=script&lang=js&"
export * from "./UploadImgOne.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgOne.vue?vue&type=style&index=0&id=0796fd34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796fd34",
  null
  
)

export default component.exports